window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    theme.scrollTop = $(window).scrollTop();
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {

      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
        $(window).scrollTop(theme.scrollTop);
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = window.theme.moneyFormat || '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 63.99em)',
    medium: 'screen and (min-width: 48em) and (max-width: 64em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64.01em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64.01em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

theme.Tabs = (function(){
  var selectors = {
    trigger: '[js-tab-trigger]',
    content: '[js-tab-content]'
  }
  function init() {
    $(selectors.trigger).on('click', function(e){
      e.preventDefault();
      var $trigger = $(this);
      if ($trigger.attr('aria-selected') == 'true') {
        return;
      }else{
        var $target = $(selectors.content+'#'+$trigger.attr('aria-controls'));
        $trigger.siblings(selectors.trigger).attr('aria-selected', false);
        $trigger.attr('aria-selected', true);
        $target.siblings(selectors.content).hide().attr('aria-hidden', true);
        $target.show().attr('aria-hidden', false);
      }
    })
  }
  return {
    init: init
  }
})();

theme.Accordion = (function(){
  var selectors = {
    container: '[js-accordion-group]',
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }
  function init() {
    $('body').on('click', selectors.header, function(evt){
      var $el = $(this);
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
          $(this).attr('aria-expanded', false);
          $(this).siblings(selectors.content).slideUp(400, function() {
            $(this).attr('aria-hidden', true);
          });
        })
        $el.attr('aria-expanded', false);
      } else {
        $el.parent().siblings().find(selectors.content, selectors.container).slideUp(400, function(){
          $(this).attr('aria-hidden', true);
        });
        $el.parent().siblings().find(selectors.header, selectors.container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
      }
    })
  }
  return {
    init: init
  }
})();
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(attr, position, options) {
    var defaults = {
      close: '[js-drawer-close]',
      open: '[js-drawer-open-' + position + ']',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container'),
      $header: $('#shopify-section-header'),
      $overlay: $('[js-drawer-overlay]')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $(attr);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    if ($('[data-product-form]').length > 0) {
      $('[data-product-form]').css('top', (0 + $(window).scrollTop()));
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();
    console.log('hi', this.$drawer)

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    $('#shopify-section-header').css('top', ($(window).scrollTop()/16)+'rem');

    if (this.position == 'nav-women' || this.position == 'nav-men') {
      slate.a11y.trapFocus({
        $container: $('[js-mobile-nav]'),
        namespace: 'trapMobile'
      })
    }else{
      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });
    }

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    if ($('[data-product-form]').length > 0) {
      $('[data-product-form]').removeAttr('style')
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    
    if (this.$activeSource) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;
    $('#shopify-section-header').removeAttr('style');

    if (this.position == 'nav-women' || this.position == 'nav-men') {
      slate.a11y.removeTrapFocus({
        $container: $('[js-mobile-nav]'),
        namespace: 'trapMobile'
      })
      if ($('html').hasClass('mobile-nav-expanded')) {
        slate.a11y.trapFocus({
          $container: $('[js-mobile-nav]'),
          namespace: 'trapMobile'
        })
      }
    }else{
      if(!$('html').hasClass('mobile-nav-expanded')) {
        slate.a11y.removeTrapFocus({
          $container: this.$drawer,
          namespace: 'drawer_focus'
        });
      }
    }

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );

    this.nodes.$overlay.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );

    this.nodes.$header.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$overlay.off('.drawer');
    this.nodes.$parent.off('.drawer');
    this.nodes.$header.off('.drawer');
  };

  return Drawer;
})();

/**
 * Footer Drawer Script
 * ------------------------------------------------------------------------------
 */

 theme.FooterDrawer = (function() {
	var selectors = {
        FooterDrawerTrigger: '[js-drawer-open-customer-care]',
		FooterDrawer: '[js-customer-care]'
	};
	function init() {
		initDrawer();
	}
	function initDrawer() {
		// Add required classes to HTML
		$(selectors.FooterDrawer)
			.attr('aria-controls', 'customer-care-drawer')
			.attr('aria-expanded', 'false');

		theme.FooterDrawer = new theme.Drawers(selectors.FooterDrawer, 'customer-care');
	}
	return {
		init: init
	};
})();

theme.MobileNavDrawer = (function() {
	var selectors = {
		mobileNavWomen: '[js-mobile-nav-women]',
		mobileNavMen: '[js-mobile-nav-men]',
    mobileNavSearch: '[js-mobile-nav-search]',
    mobileNavSale: '[js-mobile-nav-sale]',
	hamburgerNav: '[js-mobile-nav-hamburger]'
	};

	function init() {
		initDrawer();
	}

	function initDrawer() {
		theme.mobileNavWomen = new theme.Drawers(selectors.mobileNavWomen, 'nav-women');
		theme.mobileNavMen = new theme.Drawers(selectors.mobileNavMen, 'nav-men');
    theme.mobileNavSearch = new theme.Drawers(selectors.mobileNavSearch, 'nav-search');
    theme.mobileNavSale = new theme.Drawers(selectors.mobileNavSale, 'nav-sale');
    theme.hamburgerNav = new theme.Drawers(selectors.hamburgerNav, 'nav-hamburger');
	}

	return {
		init: init
	};
})();

theme.MobileNav = (function() {
  var selectors = {
  	expandTrigger: '[js-expand-trigger]',
  	secondaryLinks: '[js-secondary-link]',
  	navTrigger: '[js-nav-trigger]',
  	womensNav: '[js-mobile-nav-women]',
	hamburgerNav: '[js-mobile-nav-hamburger]',
  	mensNav: '[js-mobile-nav-men]',
    searchNav: '[js-mobile-nav-search]',
    saleNav: '[js-mobile-nav-sale]',
    promoBar: '[js-promo-bar]',
    header: '[js-header]'
  };

  function MobileNav(container) {
    this.$container = $(container);
    this.$html = $('html');
    this.$expandTrigger = this.$container.find(selectors.expandTrigger);
    this.$secondaryLinks = this.$container.find(selectors.secondaryLinks);
    this.$navTriggers = this.$container.find(selectors.navTrigger);

    this.$expandTrigger.on('click', this.toggleExpandState.bind(this));
    this.$navTriggers.on('click', this.triggerDrawer.bind(this))
  }

  MobileNav.prototype = $.extend({}, MobileNav.prototype, {
  	toggleExpandState: function(){
  		this.$html.toggleClass('mobile-nav-expanded')

			if (this.$html.hasClass('mobile-nav-expanded')) {
				slate.a11y.trapFocus({
  				$container: this.$container,
  				namespace: 'trapMobile'
  			})
  			this.$secondaryLinks.removeAttr('tabindex');
  		}else{
  			slate.a11y.removeTrapFocus({
  				$container: this.$container,
  				namespace: 'trapMobile'
  			})
  			if (this.$html.hasClass('js-drawer-open')) {
					slate.a11y.trapFocus({
	  				$container: this.$container,
	  				namespace: 'trapMobile'
	  			})
  			}
  			this.$secondaryLinks.attr('tabindex', '-1');
  		}
  	},
  	triggerDrawer: function(e){
		  e.stopPropagation();
  		var $trigger = $(e.currentTarget);

  		if(this.$html.hasClass('js-drawer-open-nav-women')){
  			theme.mobileNavWomen.close();
  			if ($trigger.data('nav') == 'women') {
  				return;
	  		}
  		}else if(this.$html.hasClass('js-drawer-open-nav-men')){
  			theme.mobileNavMen.close();
  			if ($trigger.data('nav') == 'men') {
  				return;
	  		}
  		}else if(this.$html.hasClass('js-drawer-open-nav-search')){
        theme.mobileNavSearch.close();
        if ($trigger.data('nav') == 'search') {
          return;
        }
      }else if(this.$html.hasClass('js-drawer-open-nav-sale')){
        theme.mobileNavSale.close();
        if ($trigger.data('nav') == 'sale') {
          return;
        }
      }else if(this.$html.hasClass('js-drawer-open-nav-hamburger')){
        theme.hamburgerNav.close();
        if ($trigger.data('nav') == 'hamburger') {
          return;
        }
      }
	  

  		if ($trigger.data('nav') == 'women') {
  			var $nav = $(selectors.womensNav);
  			var drawer = theme.mobileNavWomen;
			  console.log('nav', $nav);
			  console.log('drawer', theme.mobileNavWomen)
  		}else if($trigger.data('nav') == 'men'){
  			var $nav = $(selectors.mensNav);
  			var drawer = theme.mobileNavMen;
  		}else if($trigger.data('nav') == 'search'){
        var $nav = $(selectors.searchNav);
        var drawer = theme.mobileNavSearch;
      }else if($trigger.data('nav') == 'sale'){
        var $nav = $(selectors.saleNav);
        var drawer = theme.mobileNavSale;
      }else if($trigger.data('nav') == 'hamburger'){
        var $nav = $(selectors.hamburgerNav);
        var drawer = theme.hamburgerNav;
		console.log('nav', $nav);
		console.log('drawer', theme.hamburgerNav)
      }

  		var scrollTop = $(window).scrollTop();
  		var headerHeight = 49 + 32;
  		if (scrollTop < 32) {
  			var paddingTop = headerHeight + 32 - scrollTop;
  		}else{
  			var paddingTop = headerHeight;
  		}
		$nav.css('padding-top', (paddingTop/16)+'rem');
		drawer.open();
  	}
  });

  return MobileNav;
})();
theme.SiteHeader = (function() {
  var selectors = {
    megaCarousel: '[js-header-carousel]'
  };

  function SiteHeader(container) {
    this.$container = $(container);
    this.$megaCarousel = this.$container.find(selectors.megaCarousel);
    this.initCarousel();
    this.initScroll();
  }

  SiteHeader.prototype = $.extend({}, SiteHeader.prototype, {
    initCarousel: function(){
      this.$megaCarousel.flickity({
        imagesLoaded: true,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false
      });
    },

    initScroll: function() {
      $(window).on('scroll', stickyHeaderScroll);
      var $announcementBarSize = $('.promo-bar').outerHeight();
      var scroll = $(window).scrollTop();
      var threshold = $announcementBarSize;

      if (scroll > threshold) {
        $('#shopify-section-new-header').addClass('remove-top');
        $('.search-drawer--desktop').removeClass('has-top')
      } else {
        $('#shopify-section-new-header').removeClass('remove-top')
        $('.search-drawer--desktop').addClass('has-top');
      }

      function stickyHeaderScroll() {
        var $announcementBarSize = $('.promo-bar').outerHeight();
        var scroll = $(window).scrollTop();
        var threshold = $announcementBarSize;
        if (scroll > threshold) {
          $('#shopify-section-new-header').addClass('remove-top');
          $('.search-drawer--desktop').removeClass('has-top')
        } else {
          $('#shopify-section-new-header').removeClass('remove-top')
          $('.search-drawer--desktop').addClass('has-top');
        }
      }
      
    }
  });

  return SiteHeader;
})();
/**
 * Desktop Search Drawer Script
 * ------------------------------------------------------------------------------
 */

theme.SearchDrawer = (function() {
	var selectors = {
		searchTrigger: '[js-search-trigger]',
		desktopSearch: '[js-desktop-search]'
	};
	function init() {
		initDrawer();
	}
	function initDrawer() {
		// Add required classes to HTML
		$(selectors.desktopSearch)
			.attr('aria-controls', 'search-drawer')
			.attr('aria-expanded', 'false');

		theme.desktopSearch = new theme.Drawers(selectors.desktopSearch, 'desktop-search');
	}
	return {
		init: init
	};
})();
/**
 * Hamburger Drawer Script
 * ------------------------------------------------------------------------------
 */

 theme.HamburgerDrawer = (function() {
	var selectors = {
        hamburgerTrigger: '[js-hamburger-trigger]',
		hamburgerDrawer: '[js-hamburger-menu]'
	};
	function init() {
		initDrawer();
	}
	function initDrawer() {
		// Add required classes to HTML
		$(selectors.hamburgerDrawer)
			.attr('aria-controls', 'hamburger-drawer')
			.attr('aria-expanded', 'false');

		theme.hamburgerDrawer = new theme.Drawers(selectors.hamburgerDrawer, 'hamburger-menu');
	}
	return {
		init: init
	};
})();
theme.PromoBar = (function() {
	var selectors = {
		promo: '[js-promo-bar]'
	};
	function init() {
		initPromoBar();
	}
	function initPromoBar() {
        this.$promoBar = $(selectors.promo);

		if(this.$promoBar.data('autoSlide') == true) {
			this.$promoBar.flickity({
				pageDots: false,
				wrapAround: true,
				autoPlay: 5000,
				cellAlign: 'left',
				contain: true
			})
		} else {
			this.$promoBar.flickity({
				pageDots: false,
				wrapAround: true,
				autoPlay: false,
				cellAlign: 'left',
				contain: true
			})
		}


	}
	return {
		init: init
	};
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $('body').on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<div class="ajaxcart__empty"><p>Your cart is currently empty.</p></div>');
      _cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source),
      cartProducts = [],
      itemProperties = []

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_400x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        originalPrice: slate.Currency.formatMoney(cartItem.original_price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      if (cartItem.properties) {
        if (cartItem.properties.upsell) {
          itemProperties.push(cartItem.properties.upsell)
        }
      } 

      cartProducts.push(cartItem.product_id)

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };

    $cartContainer.append(template(data));

    _appendUpsell(cartProducts, itemProperties);

    _cartCallback(cart);
  }

  function _appendUpsell(products, properties){
    let uniqueProps = [...new Set(properties)];
    
    if (uniqueProps.indexOf('mens') > -1) {
      var upsell = 'mens'
    }else{
      var upsell = 'default'
    }

    fetch('/pages/cart-upsell')
    .then(response => {
      return response.text()
    }).then(html => {
      let $page = $('<div></div>')
      $page.html(html);
      let $mens = $page.find('[js-upsell-mens]');
      let $default = $page.find('[js-upsell-default]');

      if ($default.length < 1 && $mens.length < 1) {
        console.log('no upsells available')
        return;
      }

      if (upsell == 'mens' && $mens.length > 0 && products.indexOf($mens.data('id')) < 0) {
        var $upsell = $mens;
      }else if($default.length > 0){
        if (products.indexOf($default.data('id')) > -1) {
          return;
        }
        var $upsell = $default;
      }else{
        return;
      }

      $('[js-ajax-products]').append($upsell)
    }).catch((error) => {
      console.error('Error:', error)
    })
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if($el.hasClass('ajaxcart__remove')){
        qty = 0;
      }else if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _createQtySelectors() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('[js-cart-drawer]', 'cart', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '[data-product-form]',
  cartContainer: '#CartContainer',
  addToCartSelector: '[js-add-to-cart]',
  cartCountSelector: '[js-cart-count]',
  moneyFormat: theme.moneyFormat
});
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();
});

// On Quick Add Trigger
$('body').on('click', '[js-quick-add]', function(e) {
    e.preventDefault();
    var itemProperties = {};

    var variantID = $(this).data('id');
    var data = {
        quantity: 1,
        id: variantID
    }

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data:  data,
        error: function() {
            console.error;
        },
        success: function() {
            ajaxCart.load();
        }
    })
})

// On Quick Shop Trigger
$('body').on('click', '[js-quick-shop-trigger]', function(e) {
  var id = $(this).data('id');
  var $quickShop = $('[js-quick-shop-' + id + ']');
  $quickShop.slideToggle();
  $quickShop.css('display', 'grid');
});

// On Quick Shop Variant Select
$('body').on('change', '[js-quick-shop-variant-select]', function(e) {
  var optionSelected = $("option:selected", this);
  var valueSelected = this.value;
  $(this).siblings('[js-quick-add]').data('id', valueSelected);
});
// On Index Hero Link Hover
$('[js-index-hero-link-first-half]').hover(
  function() {
    $("[js-index-hero-first-half]").addClass("active");
    $("[js-index-hero-last-half]").removeClass("active");
  }
);
$('[js-index-hero-link-last-half]').hover(
  function() {
    $("[js-index-hero-last-half]").addClass("active");
    $("[js-index-hero-first-half]").removeClass("active");
  }
);

/*================ Modules ================*/
theme.HeroCarousel = (function() {

  var selectors = {

  };

  function HeroCarousel(container) {
    this.$container = $(container);
    this.$carousel = this.$container;

    this.initCarousel();
  }

  HeroCarousel.prototype = $.extend({}, HeroCarousel.prototype, {
    initCarousel: function(){
      console.log('init carousel');

      this.$carousel.flickity({
        pageDots: false,
        imagesLoaded: true,
        arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
        wrapAround: true
      })
    }
  });

  return HeroCarousel;
})();


/*================ Modules ================*/
// =require modules/hero-carousel.js

/*================ Modules ================*/
// =require modules/hero-carousel.js

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[js-add-to-cart]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    imageCarousel: '[js-product-images]',
    imagesModal: '[js-images-modal]',
    imagesModalTrigger: '[js-images-modal-trigger]',
    crossSellSelector: '[js-cross-sell-option]',
    crossSellBtn: '[js-cross-sell]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);
    this.$carousel = this.$container.find(selectors.imageCarousel);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    //Custom theme js

    var productPersonalizer = $('.product-personalizer');

    if(productPersonalizer.length >  0) {
      console.log('Product Personalizer detected, moving div');
      $('.product--custom__place-to-append').append(productPersonalizer)
    } else {
      console.log('No Product Personalizer')
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.currentVariant = {
      variant: this.variants.currentVariant
    }

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.initProductImageModal();


    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    this.initCarousel();
    this.initRecommendations();
    this.updateAddToCartState(this.currentVariant);

    //New cross-sell-code
    $(selectors.crossSellSelector).on('change', function(evt){
      var selectedValue = evt.target.value;
      var $selectedSelector = $(this);
      var $button = $selectedSelector.siblings('.cross-sell-btn');
      if(selectedValue !== 'default') {
        $button.attr('cross-sell-product', evt.target.value);
        $button.attr('disabled', false);
      } else {
        $button.attr('disabled', true);
      }
    })

    $(selectors.crossSellBtn).on('click', function(evt){
      evt.preventDefault();
      var selectedId = $(this).attr('cross-sell-product')
      var parsedId = parseInt(selectedId);

      var data = {
        quantity: 1,
        id: parsedId
      }
    
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: data,
        success: function() {
          ajaxCart.load();
        },
        error: function() {
          console.log('Error')
          ajaxCart.load()
        }
      })
    })

  }

  Product.prototype = $.extend({}, Product.prototype, {
    initCarousel: function(){
      var $carousel = this.$carousel
      
      enquire.register(theme.config.mediaQueries.mediumDown,{
        match: function(){
          $carousel.flickity({
            imageLoaded: true,
            pageDots: false,
            prevNextButtons: false,
            contain: true,
            cellAlign: 'left'
          })
        },
        unmatch: function(){
          if ($carousel.hasClass('flickity-enabled')) {
            $carousel.flickity('destroy');
          }
        }
      })
    },
    initRecommendations: function(){
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('[js-product-recommendations]');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
            
            theme.ProductCard.init();
          })
          .catch(e => {
            console.error(e);
          });
      };

      const productRecommendationsSection = document.querySelector('[js-product-recommendations]');
      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

      observer.observe(productRecommendationsSection);
    },

    initProductImageModal: function() {
      var modal = $(selectors.imagesModal).removeClass('hidden').remodal();

      $(selectors.imagesModalTrigger, this.$container).on(
        'click' + this.namespace, 
        function() { modal.open() }
      );
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (!variant) {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).html('Unavailable');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).html('Add To Bag');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).html('Sold Out');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * Product Card Script
 * ------------------------------------------------------------------------------
 */

theme.ProductCard = (function() {
  function init() {
    var $productCard = $('[js-product-card]');

    $productCard.each(function(){
      if(!$(this).hasClass('initialized')){
        initProductCard($(this))
      }
    })
  }

  function initProductCard($card){
    var $productCard = $card;
    var $carousel = $productCard.find('[js-product-card-carousel]');
    var $colors = $productCard.find('[js-color-count]')

    initCarousel($carousel, $productCard);
    initColorCount($colors, $productCard.data('title'))
    $productCard.addClass('initialized');
  }

  /**
   * Initialize carousel
   */
  function initCarousel($carousel, $card) {
    var carouselOptions = {
      pageDots: false,
      wrapAround: true,
      arrowShape: 'M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z',
      imagesLoaded: true
    }
    $carousel.flickity(carouselOptions);
    $carousel.flickity('resize');

    $carousel.on('change.flickity', function(e, index){
      var slideIndex = index;
      var $targetDot = $card.find('[js-dot][data-index="'+slideIndex+'"]');
      $targetDot.addClass('product-card__dot--active').siblings().removeClass('product-card__dot--active')
    })

    var $dot = $card.find('[js-dot]');
    $dot.on('click', function(){
      var targetIndex = $(this).data('index');
      $carousel.flickity('select', targetIndex)
    })
  }

  function initColorCount($colorContainer, productTitle){
    let $colorCount = $('body').find('[js-product-'+productTitle+']')
    let colors = $colorCount.attr('data-colors') - 1;
    if (colors > 0) {
      if (colors > 1) {
        $colorContainer.html('+'+colors+' colors')
      }else{
        $colorContainer.html('+'+colors+' color')
      }
    }else{
      $colorContainer.remove()
    }
  }

  return {
    init: init
  };
})();

/*================ Templates ================*/
theme.Address = (function(){
  var selectors = {
    editAddressTriggers: '[data-form-target]',
    deleteAddressTriggers: '[js-delete-address]'
  }

  function Address(container) {
    this.$container = $(container);
    this.$modal = $('[data-remodal-id="account-address-edit"]').remodal({
      hashTracking: false
    })

    $(document).on('closed', '.remodal', function (e) {
      $('[js-address-edit-form]').hide();
    });

    this.initNewProvince();
    this.initEditProvince();

    $(selectors.editAddressTriggers, this.$container).on('click', this.editAddress.bind(this));
    $(selectors.deleteAddressTriggers, this.$container).on('click', this.deleteAddress.bind(this));
  }

  Address.prototype = $.extend({}, Address.prototype, {
    initNewProvince: function(){
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    },
    initEditProvince: function(){
      $(selectors.editAddressTriggers, this.$container).each(function(){
        var id = $(this).data('form-target');
        var countrySelector = 'AddressCountry_' + id;
        var provinceSelector = 'AddressProvince_' + id;
        var containerSelector = 'AddressProvinceContainer_' + id;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      })
      
    },
    editAddress: function(e){
      var $trigger = $(e.currentTarget);
      var id = $trigger.data('form-target');
      var $form = $('#address_form_' + id)
      $form.show();
      this.$modal.open()
    },
    deleteAddress: function(e){
      var $trigger = $(e.currentTarget);
      var formId = $trigger.data('form-id');
      var confirmMessage = $trigger.data('confirm-message');
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    }
  });

  return Address;
})();
theme.Login = (function(){
  var selectors = {
    loginForm: '[js-login-form]',
    resetForm: '[js-reset-form]',
    showLogin: '[js-show-login]',
    showReset: '[js-show-reset]'
  }

  function Login(container) {
    this.$container = $(container);
    this.$loginForm = $(selectors.loginForm, this.$container);
    this.$resetForm = $(selectors.resetForm, this.$container);
    this.$showLoginTrigger = $(selectors.showLogin, this.$container);
    this.$showResetTrigger = $(selectors.showReset, this.$container);

    this.$showResetTrigger.on('click', this.showResetForm.bind(this));
    this.$showLoginTrigger.on('click', this.showLoginForm.bind(this));

    this.checkUrlHash();
  }

  Login.prototype = $.extend({}, Login.prototype, {
    checkUrlHash: function(){
      var hash = window.location.hash;
      // Allow deep linking to reset password form
      if (hash === '#recover') {
        this.$loginForm.hide();
        this.$resetForm.show();
      }
    },
    showResetForm: function(e){
      e.preventDefault();
      this.$loginForm.hide();
      this.$resetForm.show();
      window.location.hash = 'recover'
    },
    showLoginForm: function(e){
      e.preventDefault();
      this.$resetForm.hide();
      this.$loginForm.show();
      window.location.hash = ''
    }
  });

  return Login;
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__overview', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__overview"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__orders, #account__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();
theme.Blog = (function() {
  var selectors = {
    infiniteContainer: '[js-articles]',
    infiniteObject: '[js-article]',
    paginationPath: '[js-pagination-path]',
    paginationContainer: '[js-pagination-container]'
  }

  function Blog(container) {
    this.$container = $(container);
    this.initInfiniteScroll();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    initInfiniteScroll: function(){
      var sections = new slate.Sections();
      var $infiniteProducts = $(selectors.infiniteContainer, this.$container)
      $infiniteProducts.infiniteScroll({
        path: selectors.paginationPath,
        append: selectors.infiniteObject,
        history: false
      })

      $infiniteProducts.on( 'last.infiniteScroll', function( event, response, path ) {
        $(selectors.paginationContainer).hide();
      });
    }
  });

  return Blog;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Collection template.
 *
   * @namespace collection
 */

theme.Collection = (function() {

  var selectors = {
    gridChangeTrigger: '[js-grid-change-trigger]',
    collectionProducts: '[js-collection-products]',
    collectionFilterSortTrigger: '[js-collection-filter-sort-trigger]',
    collectionFilter: '[js-collection-filter]',
    collectionSort: '[js-collection-sort]'
  };

  /**
   * Collection section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);
    this.selectFilter(this.$container);
    this.gridChange(this.$container);
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    /**
     * On click, open filter/sort menu
     */
    selectFilter: function(container) {

      // Change clear all button text on load
      $(window).load(function() {
        var closeButton = '<button class="btn collection-filter__close-btn--no-width close-btn--desktop-only" js-collection-filter-sort-trigger data-menu="close">Show Results</button>';
        $('.boost-pfs-filter-button.boost-pfs-filter-clear-all').html('CLEAR');
        $('.boost-pfs-filter-button.boost-pfs-filter-clear-all').parent().prepend(closeButton)
      });

      container.on('click', selectors.collectionFilterSortTrigger, function () {

        // Grab menu data
        var menu = $(this).data('menu');

        // Menu Cases
        switch (menu) {
          case 'filter':
            if ( $(this).hasClass('active') ) {
              $(selectors.collectionFilter, container).slideUp();
            } else {
              $(selectors.collectionFilter, container).slideDown();
              $(selectors.collectionSort, container).slideUp();
            }
            break;
          case 'sort':
            if ( $(this).hasClass('active') ) {
              $(selectors.collectionSort, container).slideUp();
            } else {
              $(selectors.collectionFilter, container).slideUp();
              $(selectors.collectionSort, container).slideDown();
            }
            break;
          case 'close':
              $(selectors.collectionFilter, container).slideUp();
              $(selectors.collectionSort, container).slideUp();
            break;
        }

        // Set active
        if ( $(this).hasClass('active') ) {
          $(this).removeClass('active');
        } else {
          $(selectors.collectionFilterSortTrigger, container).removeClass("active");
          $(this).addClass('active');
        }

      });
    },

    /**
     * On click, change grid columns
     */
    gridChange: function(container) {
		  container.on('click', selectors.gridChangeTrigger, function () {

        // Grab grid data
        var grid = $(this).data('grid');

        // Set active
        $(selectors.gridChangeTrigger, container).removeClass("active");
        $(this).addClass('active');

        // Grid Cases
        switch (grid) {
          case 'small':
            $(selectors.collectionProducts, container).attr('class', 'collection-grid grid--small boost-pfs-filter-products');
            $(selectors.gridChangeTrigger, container).removeClass("active");
            $(selectors.gridChangeTrigger, container).filter('[data-grid="small"]').addClass("active");
            break;
          case 'large':
            $(selectors.collectionProducts, container).attr('class', 'collection-grid grid--large boost-pfs-filter-products');
            $(selectors.gridChangeTrigger, container).removeClass("active");
            $(selectors.gridChangeTrigger, container).filter('[data-grid="large"]').addClass("active");
            break;
        }

        // Resize flickity
        var $carousel = $('[js-product-card-carousel]');
        $carousel.each(function() {
          if ($(this).hasClass('flickity-enabled')) {
            $(this).flickity('resize');
          }
        });

	    });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Collection;
})();

theme.DenimCategory = (function() {
    var selectors = {
        categories: '[js-categories]',
        seeMore: '[js-see-more]'
    }
  
    function DenimCategory(container) {
        this.$container = $(container);
        this.$categories = $(selectors.categories, this.$container);
        this.$seeMore = $(selectors.seeMore, this.$container);

        _getCollection = function(url) {
            return fetch(url)
                .then(response => response.text())
                .then((text) => {
                const html = text;
                const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
                return parsedHTML;
                })
        }


        this.$categories.each(function(){
            $(this).on('click', function(evt){
                evt.preventDefault();
                var $categoryName = $(this).data('category-name');
                var $categorySection = $('[name="' + $categoryName + '"]');
                var $headerSize = $('#shopify-section-header').outerHeight();
                var $scrollingDistance = $categorySection.offset().top - $headerSize;

                $('html, body').animate(({
                    scrollTop: $scrollingDistance
                }), 1000);
            })
        })

        this.$seeMore.each(function(){
            $(this).on('click', async(e) => {
                const $url = $(this).attr('data-url') + '?view=twelve-limit';
                let $productsContainer = $(this).parent().parent().find('[js-section-products]')
                const parsedHTML = await _getCollection($url);

                const newProducts = parsedHTML.querySelector('[js-12-products]')
                
                if(newProducts) {
                    $productsContainer.html($(newProducts).children());
                    theme.ProductCard.init();
                }
                $(this).hide();
                $(this).siblings('.show-all-btn').show();
            })


        })



    }
  
  
    return DenimCategory;
  })();

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('mobile-nav', theme.MobileNav);
  sections.register('header', theme.SiteHeader);
  sections.register('collection', theme.Collection);
  sections.register('hero-carousel', theme.HeroCarousel);
  sections.register('blog', theme.Blog);
  sections.register('login', theme.Login);
  sections.register('address', theme.Address);
  sections.register('denim-category', theme.DenimCategory);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init mobile drawer
  theme.MobileNavDrawer.init();
  theme.Accordion.init();
  theme.Tabs.init();
  theme.SearchDrawer.init();
  theme.HamburgerDrawer.init();
  theme.FooterDrawer.init();

  // init promobar
  theme.PromoBar.init();
  

  // init product card
  theme.ProductCard.init();
});
